import { defineStore } from 'pinia'
import type {
  Competition,
  Direction,
  DirectionPage,
  News,
  SchoolDetails,
  Trainer,
} from '~/api'

export const useDirectionStore = defineStore('direction', () => {
  const api = useApi()

  const commonStore = useCommonStore()
  const regionId = computed(() => commonStore.currentRegionId || '')

  const pageData = ref<DirectionPage | null>(null)

  const fetchDirection = async (id: string) => {
    pageData.value = (
      await api.public.direction(id, {
        region_id: regionId.value,
      })
    ).data
  }

  const direction = computed(
    () => pageData.value?.direction || ({} as Direction),
  )

  const schools = computed(
    () => pageData.value?.schools || ([] as SchoolDetails[]),
  )

  const news = computed(() => pageData.value?.news || ([] as News[]))
  const competitions = computed(
    () => pageData.value?.competitions || ([] as Competition[]),
  )

  const trainers = computed(() => pageData.value?.trainers || ([] as Trainer[]))
  const subdirections = computed(
    () => pageData.value?.subdirections || ([] as Direction[]),
  )

  return {
    pageData,
    direction,
    competitions,
    news,
    regionId,
    schools,
    subdirections,
    trainers,

    fetchDirection,
  }
})
